/* eslint-disable import/no-default-export */
import AddressFormWrapper from './components/containers/AddressFormWrapper';
import AddressFormComponent from './components/containers/AddressForm';
import AddressSelectorComponent from './components/containers/AddressSelector';
import ZipCodeComponent from './components/fields/ZipCode';
import ControlledAddressFormComponent from './components/containers/ControlledAddressForm';

export const AddressForm = AddressFormComponent;
export const AddressSelector = AddressSelectorComponent;
export const ZipCode = ZipCodeComponent;
export const ControlledAddressForm = ControlledAddressFormComponent;

export default AddressFormWrapper;
